const theme = {
    colors: {
        black: '#212121',
        blue200: '#CDDCE2',
        burgundy300: '#9B7377',
        burgundy400: '#4C2C2C',
        caramel200: '#F5E2CA',
        caramel400: '#A5663E',
        darkgray: '#5A5A5A',
        error300: '#DD7B7B',
        error500: '#CD5656',
        green300: '#869A99',
        green600: '#204A46',
        grey100: '#F2F2F2',
        grey300: '#B1B1B1',
        grey500: '#808080',
        success300: '#AEC690',
        success500: '#498D73',
        yellow400: '#CC9846',
        white: '#FFFFFF',
        sweetcorn: '#FFE484',
        bittersweet: '#F1B658',
        rose300: '#DDCCCD',
    },
};

export default theme;
